export default __webpack_public_path__ + "static/media/career_coaching.a2ce010d.svg";